// extracted by mini-css-extract-plugin
export var container = "_qa-0";
export var dotAnimation = "_qa-2";
export var dotsLoading = "_qa-1";